import { Select } from '@components'
import React from 'react'
import { Controller } from 'react-hook-form'
import { useTranslation } from 'react-i18next'
import { useWorkflowCatalogs } from './WorkflowCatalogsContext'
import { useWorkflowConfigForm } from './useWorkflowConfigForm'
import { optionIncludesValue } from './formOptionUtils'

interface EventTriggerFormValues {
  event_type: string
}

interface Props {
  nodeId: string
  config: EventTriggerFormValues
  onChange: (config: EventTriggerFormValues) => void
}

export const EventTriggerConfigForm: React.FC<Props> = ({ nodeId, config, onChange }) => {
  const [t] = useTranslation()
  const { eventTriggerTypes } = useWorkflowCatalogs()
  const { control, pushConfig } = useWorkflowConfigForm<EventTriggerFormValues>({
    defaultValues: config,
    onChange
  })

  return (
    <Controller
      name="event_type"
      control={control}
      render={({ field, fieldState }) => (
        <Select
          id={`workflow-event-trigger-type-${nodeId}`}
          name={`workflow-event-trigger-type-${nodeId}`}
          label={t('workflows.config.eventTriggerType')}
          value={field.value}
          errors={fieldState.error}
          onChange={event => {
            field.onChange(event.target.value)
            pushConfig()
          }}
          onBlur={field.onBlur}
        >
          {eventTriggerTypes.map(option => (
            <option key={option.value} value={option.value}>
              {option.label}
            </option>
          ))}
          {!optionIncludesValue(eventTriggerTypes, field.value) && field.value && (
            <option value={field.value}>{field.value}</option>
          )}
        </Select>
      )}
    />
  )
}
